import { REPORTED_USAGE_MERCHANTS } from 'features/Programs/Editing/ReportedUsageProgramEditing'

type PillColor = 'green' | 'red' | 'yellow' | 'gray'

export const programMerchantChoices = (ids: string[]) =>
  REPORTED_USAGE_MERCHANTS.filter((item) => ids.includes(item.id))

export const merchantLabel = (merchant: string) =>
  REPORTED_USAGE_MERCHANTS.find((item) => item.id === merchant)?.label ||
  merchant

export const matchRate = (matched: number, parsed: number) => {
  if (!parsed) {
    return 0
  }
  return Math.round((matched / parsed) * 100)
}

export const fileExtension = (filename: string) => {
  const extension = filename.split('.').pop()
  return extension && extension !== filename ? extension.toUpperCase() : 'FILE'
}

export const statusPill = (
  status: string
): { text: string; color: PillColor } => {
  if (status === 'succeeded') return { text: 'Succeeded', color: 'green' }
  if (status === 'failed') return { text: 'Failed', color: 'red' }
  if (status === 'processing') return { text: 'Processing', color: 'yellow' }
  return { text: 'Pending', color: 'gray' }
}

export const formatUploadedDate = (value?: string | null) => {
  if (!value) {
    return ''
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return ''
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date)
}

export type UploadHistoryRow = {
  id: string
  originalFilename: string
  merchant: string
  merchantName: string
  status: string
  statusText: string
  parsedCount: number
  matchedCount: number
  createdAt: string
  uploadedOn: string
}

export const filterUploads = (
  rows: UploadHistoryRow[],
  search: string,
  filters: { key: string; value: string }[],
  sortDirection: 'asc' | 'desc' | null
) => {
  const needle = search.trim().toLowerCase()
  const grouped: Record<string, string[]> = {}
  filters.forEach((item) => {
    grouped[item.key] = [...(grouped[item.key] || []), item.value]
  })
  let next = rows.filter((row) => {
    if (
      needle &&
      ![row.originalFilename, row.merchantName, row.statusText, row.uploadedOn]
        .join(' ')
        .toLowerCase()
        .includes(needle)
    ) {
      return false
    }
    return Object.entries(grouped).every(([key, values]) =>
      values.includes(String(row[key as keyof UploadHistoryRow] ?? ''))
    )
  })
  if (sortDirection) {
    next = [...next].sort((a, b) => {
      const result = a.createdAt.localeCompare(b.createdAt)
      return sortDirection === 'asc' ? result : -result
    })
  }
  return next
}
